import { render, staticRenderFns } from "./arrayPreview.vue?vue&type=template&id=0dadb162&scoped=true"
import script from "./arrayPreview.vue?vue&type=script&lang=js"
export * from "./arrayPreview.vue?vue&type=script&lang=js"
import style0 from "./arrayPreview.vue?vue&type=style&index=0&id=0dadb162&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dadb162",
  null
  
)

export default component.exports